// -------------------------------------------------------------
// Dynamically Update Offer Calculators based on cart contents
// -------------------------------------------------------------

async function updateValue() {
  console.log('--- Triggering updateValue() function ---'); 
  try {
    const response = await fetch('/cart.js');
    console.log('Fetched cart data.');
    const cart = await response.json();
    console.log('Cart object:', cart); 

    // get value of card offer
    const cardOfferValue = $('#cartOffercardVal').html();
    console.log('Value to be written:', cardOfferValue); 

    //write to class for card offer
    const messageElements = document.querySelectorAll('#write-card-offer-message'); 
    
    if (messageElements.length > 0) {
      messageElements.forEach(element => {
        element.innerHTML = cardOfferValue; //write
      });
      console.log(`Successfully wrote value "${cardOfferValue}" to all ${messageElements.length} elements with ID "card-offer-message"`); 
    } else {
      console.error('Error: Element with ID "card-offer-message" not found.');
    }
    
    
    // Get value of free shipping
    const freeShipValue = $('.cart-ship-cal').html();
    console.log('Value to be written for second class:', freeShipValue);

    // write to class for free shipping
    const secondMessageElements = document.querySelectorAll('#write-shipping-dynamic');

    // Write the new value to all elements with the new class
    if (secondMessageElements.length > 0) {
      secondMessageElements.forEach(element => {
        element.innerHTML = freeShipValue; //write
      });
      console.log(`Successfully wrote value "${freeShipValue}" to all ${secondMessageElements.length} elements with class "write-card-offer-message-second"`); 
    } else {
      console.error('Error: Elements with class "write-card-offer-message-second" not found.');
    }

    // --- New Code Ends Here ---

  } catch (error) {
    console.error('An error occurred during the update process:', error);
  }
}

// -------------------------------------------------------------
// Listeners to trigger updates
// -------------------------------------------------------------

// Save to the original fetch function
const originalFetch = window.fetch;

// Overwrite the native fetch function with our own wrapper
window.fetch = function(...args) {
  const [url, options] = args;
  
  // Check if the URL is related to the cart
  if (url.includes('/cart')) {
    console.log(`Intercepting fetch call to: ${url}`);
    
    // Call the original fetch function
    const promise = originalFetch.apply(this, args);
    
    // Check for success after the fetch is complete
    promise.then(response => {
      // If the cart has been modified run function
      if (response.ok && (url.includes('/add') || url.includes('/change') || url.includes('/update') || url.includes('/remove'))) {
        console.log('Cart data change detected.');
        updateValue();
      }
      return response;
    });

    return promise;
  }
  // For all other fetch calls, just run the original fetch
  return originalFetch.apply(this, args);
};

// Initial call to set the value when the page loads
document.addEventListener('DOMContentLoaded', updateValue);